import React, { useEffect } from "react";
import styled from "styled-components";
import * as Library from "../../../utils/Library";
import Checkbox from "../checkbox/Checkbox";
import FullScreenOverlay from "../overlay/FullScreenOverlay";
import DialogBoxComponent from "./DialogBoxComponent";

// #region SCOPED CSS
const DialogLayoutStyled = styled.div`
    .frame-258,
    .frame-258 * {
        box-sizing: border-box;
    }
    .frame-258 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        margin-bottom: 32px;
    }
    .frame-285 {
        display: flex;
        flex-direction: column;
        gap: 32px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-160 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-286 {
        padding: 0px 32px 0px 32px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .declining-invitation {
        color: #ffffff;
        text-align: center;
        font-family: "Roboto-Bold", sans-serif;
        font-size: 18px;
        font-weight: 700;
        position: relative;
        flex: 1;
    }
    .please-confirm-you-want-to-decline-the-product-invitation {
        color: var(--text-icons-gray-100, #d1d1d1);
        text-align: center;
        min-height: 28px;
        width: 312px;
        /* Subtitle 2 */
        font-family: Roboto;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
    }
    .do-you-mind-sharing-the-reason {
        color: #ffffff;
        text-align: left;
        font-family: "Roboto-Bold", sans-serif;
        font-size: 14px;
        letter-spacing: 0.0025em;
        font-weight: 700;
        position: relative;
        align-self: stretch;
        width: 312px;
    }
    .do-you-mind-sharing-the-reason.sub-reason-text {
        font-size: 12px;
        font-weight: 400;
        color: #7c868b;
    }
    .frame-1000011146 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .checkbox-label {
        display: flex;
        flex-direction: row;
        gap: 8px;
        //height: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }

    .text {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--subtitle-2-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-2-font-size, 12px);
        font-weight: var(--subtitle-2-font-weight, 400);
        position: relative;
        flex: 1;
    }
    .check2 {
        opacity: 0;
        width: 62.5%;
        height: 62.5%;
        position: absolute;
        right: 18.75%;
        left: 18.75%;
        bottom: 18.75%;
        top: 18.75%;
        overflow: visible;
    }
    .check3 {
        opacity: 0;
        width: 62.5%;
        height: 62.5%;
        position: absolute;
        right: 18.75%;
        left: 18.75%;
        bottom: 18.75%;
        top: 18.75%;
        overflow: visible;
    }
    .check4 {
        opacity: 0;
        width: 62.5%;
        height: 62.5%;
        position: absolute;
        right: 18.75%;
        left: 18.75%;
        bottom: 18.75%;
        top: 18.75%;
        overflow: visible;
    }
    .simple {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .input-selector-inverted {
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 76px;
        position: relative;
    }
    .search {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .frame-48 {
        background: var(--backgrounds-and-lines-n-600, #10141b);
        border-radius: 4px;
        padding: 10px 12px 10px 12px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
        border-style: none;
        //noresize?
        resize: none;
    }
    .frame-48.disabled {
        opacity: 0.8;
        cursor: not-allowed;
    }

    .please-specify {
        color: var(--text-and-icons-gray-200, #7c868b);
        text-align: left;
        font-family: var(--subtitle-2-font-family, "Roboto-Italic", sans-serif);
        font-size: var(--subtitle-2-font-size, 12px);
        font-weight: var(--subtitle-2-font-weight, 400);
        font-style: var(--subtitle-2-font-style, italic);
        position: relative;
        flex: 1;
    }
`;
// #endregion

/**
 * DialogCancelReasonsComponent is a React functional component that renders a dialog
 * for declining an invitation with a reason. It provides options for the user to
 * specify a reason for declining and confirm or cancel the action.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {Function} props.onCancelClicked - Callback function triggered when the cancel button is clicked.
 * @param {Function} props.onConfirmClicked - Callback function triggered when the confirm button is clicked.
 * @param {Object} props.reasonObj - Object representing the selected reason and additional reason text.
 * @param {Function} props.setReasonObj - Function to update the reason object state.
 * @param {Array} [props.reasonsArray=[]] - Array of predefined reasons for declining.
 * @param {boolean} [props.visible=true] - Determines whether the dialog is visible.
 * @param {string} [props.title] - Title of the dialog box.
 * @param {string} [props.message] - Message displayed in the dialog box.
 * @param {string} [props.confirmText="CONFIRM"] - Text for the confirm button.
 * @param {string} [props.cancelText="CANCEL"] - Text for the cancel button.
 * @param {string} [props.heading="DECLINING..."] - Heading text displayed in the dialog.
 * @param {string} [props.reasonText="Do you mind sharing the reason?"] - Text prompting the user to share a reason.
 * @param {string} [props.subReasonText=null] - Optional subtext shown under the reason prompt.
 * @param {string} [props.headingColor="var(--text-icons-red-500)"] - Color for the heading text.
 *
 * @returns {JSX.Element} The rendered DialogCancelReasonsComponent.
 */
export default function DialogCancelReasonsComponent(props) {
    const { onCancelClicked, onConfirmClicked, reasonObj, setReasonObj, reasonsArray = [], visible = true } = props;

    const {
        title,
        message,
        confirmText = "CONFIRM",
        cancelText = "CANCEL",
        heading = "DECLINING...",
        reasonText = "Do you mind sharing the reason?",
        subReasonText = null,
        headingColor = "var(--text-icons-red-500)"
    } = props;

    return (
        <FullScreenOverlay show={visible}>
            <DialogBoxComponent
                title={title}
                useAlternativeLayout={
                    <DeclineReasonLayout
                        reasonObj={reasonObj}
                        setReasonObj={setReasonObj}
                        message={message}
                        reasonText={reasonText}
                        reasonsArray={reasonsArray}
                        subReasonText={subReasonText}
                    />
                }
                confirmText={confirmText}
                cancelText={cancelText}
                heading={heading}
                headingColor={headingColor}
                onClickYes={() => {
                    if (reasonObj.isOtherReason && reasonObj.otherReasonText === "") {
                        Library.showToastMessage({
                            type: "error",
                            title: "Please specify the reason for declining the invitation."
                        });
                        return;
                    }
                    if (!reasonObj?.isOtherReason && !reasonObj?.reasonNumber && reasonObj?.reasonNumber !== 0) {
                        Library.showToastMessage({
                            type: "error",
                            title: "Please select a reason for declining the invitation."
                        });
                        return;
                    }

                    onConfirmClicked(reasonObj);
                }}
                onClickNo={() => {
                    onCancelClicked();
                }}
            />
        </FullScreenOverlay>
    );
}

const DeclineReasonLayout = props => {
    const { reasonObj, setReasonObj, message, reasonText, reasonsArray, subReasonText } = props;
    const otherReasonRef = React.createRef();

    useEffect(() => {
        if (reasonObj.isOtherReason) {
            otherReasonRef.current.focus();
        }
    }, [reasonObj.isOtherReason]);

    return (
        <DialogLayoutStyled className="DialogLayout">
            <div className="frame-258">
                <div className="frame-285">
                    <div className="frame-160">
                        <div className="please-confirm-you-want-to-decline-the-product-invitation">{message}</div>
                        <div className="do-you-mind-sharing-the-reason">{reasonText}</div>
                        {subReasonText && (
                            <div className="do-you-mind-sharing-the-reason sub-reason-text">{subReasonText}</div>
                        )}
                        <div className="frame-1000011146">
                            {reasonsArray?.map((reason, index) => (
                                <div className="checkbox-label">
                                    <Checkbox
                                        isChecked={reasonObj?.reasonNumber === index}
                                        onCheckboxClick={() => {
                                            setReasonObj({
                                                reasonNumber: index,
                                                isOtherReason: false,
                                                reasonTitle: reason,
                                                otherReasonText: ""
                                            });
                                        }}
                                    />
                                    <div className="text">{reason}</div>
                                </div>
                            ))}

                            <div className="checkbox-label">
                                <Checkbox
                                    isChecked={reasonObj.isOtherReason}
                                    onCheckboxClick={() => {
                                        setReasonObj({
                                            reasonNumber: "",
                                            isOtherReason: true,
                                            reasonTitle: "",
                                            otherReasonText: ""
                                        });
                                    }}
                                />{" "}
                                <div className="text">Other reasons:</div>
                            </div>
                            <div className="simple">
                                <div className="input-selector-inverted">
                                    <div className="search">
                                        <textarea
                                            ref={otherReasonRef}
                                            className={`frame-48 ${reasonObj.isOtherReason ? "" : "disabled"}`}
                                            placeholder="Please specify"
                                            value={reasonObj.otherReasonText}
                                            disabled={!reasonObj.isOtherReason}
                                            onChange={e => {
                                                setReasonObj({ ...reasonObj, otherReasonText: e.target.value });
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </DialogLayoutStyled>
    );
};
